async function restapi(method, host, page, data, headers = {}, isEcho = false) {
  let url = `${host}${page}`;
  if (isEcho) console.log("url: ", url);

  const token = sessionStorage.getItem('token');
  
  if (headers === undefined) headers = {};
  if (headers['Content-Type'] === undefined) headers['Content-Type'] = 'application/json';
  if (headers['Authorization'] === undefined && token) headers.Authorization = `Bearer ${token}`;

  const options = {
    method: method,
    headers: headers,
  };

  console.log("options: ", options);

  if (method.toUpperCase() === 'GET') {
    url += `?${new URLSearchParams(data).toString()}`;
  } else {
    options.body = JSON.stringify(data);
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    console.error(response);
    throw new Error(`Failed to fetch stock search: ${response.status}`);
  }

  return await response.json();
}

async function isValidBankAccount(bank, account, name, isEcho = false) {
  const method = 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/nicepay/isValidBankAccount';
  const data = {
    bank: bank,
    account: account,
    name: name,
  };
  console.log("data: ", data);

  const response = await restapi(method, host, page, data);
  if (isEcho) console.log("response: ", response);

  return response.result;
}

async function person_update(person_id, data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/${person_id}`;
  const response = await restapi(method, host, page, data);
  if (!response.result) throw new Error(`개인정보 변경 실패! 원인 - ${response.message}`);
  return response.data;
}

async function get_person_signature(person_id) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/signature/${person_id}`;
  const response = await restapi(method, host, page, {}, {}, true);
  if (!response.result) throw new Error(`서명 이미지 조회 실패! 원인 - ${response.message}`);
  return response.data;
} 

async function person_signature_update(person_id, data) {
  const method = 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/signature/${person_id}`;
  const response = await restapi(method, host, page, data);
  if (!response.result) throw new Error(`서명 이미지 변경 실패! 원인 - ${response.message}`);
  return response.data;
}

async function person_nameImage_delete(person_id) {
  const method = 'DELETE';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/name_image/${person_id}`;
  const response = await restapi(method, host, page, {});
  if (!response.result) throw new Error(`서명 이미지 삭제 실패! 원인 - ${response.message}`);
  return response.data;
}

async function person_signatureImage_delete(person_id) {
  const method = 'DELETE';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/signature_image/${person_id}`;
  const response = await restapi(method, host, page, {});
  if (!response.result) throw new Error(`서명 이미지 삭제 실패! 원인 - ${response.message}`);
  return response.data;
}

async function get_testing_teacher_documents(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_teacher/documents';

  const response = await restapi(method, host, page, json);
  return response;
}

async function testing_teacher_document_update(pkValue, data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/testing_teacher_document/${pkValue}`;

  const response = await restapi(method, host, page, data, {}, true);
  if (!response.result) throw new Error(`테스트 교사 문서 등록 실패! 원인 - ${response.message}`);
  return response.data;
}

module.exports = {
  restapi,
  isValidBankAccount,
  person_update,
  get_person_signature,
  person_signature_update,
  person_nameImage_delete,
  person_signatureImage_delete,
  get_testing_teacher_documents,
  testing_teacher_document_update
};
